<template>
  <div id="intent">
    <template v-if="!loading">
      <!-- $route.name != 'livechat' -->
      <v-container>
        <slot name="header"></slot>
        <v-layout wrap v-if="!isGetstarted">
          <v-flex
            xs12
            :class="`form-control ${$route.name != 'allinonechat' ? 'sm4' : 'sm8'}`"
            style="display: inherit;"
          >
            <div class="input-icons">
              <i class="fa fa-search icon"></i>
              <input
                @keyup.enter="
                  pageNumber = 1
                  getIntent()
                "
                type="text"
                v-model="search"
                class="form-control"
                :placeholder="$t('Search Conversation Name')"
                style="margin-bottom: 10px"
              />
              <v-btn v-show="search.length > 0" @click="clearSearch" icon class="icon-close">
                <i class="fa fa-close"></i
              ></v-btn>
            </div>
          </v-flex>
          <v-flex xs12 sm2 class="form-control" style="display: inherit;">
            <multiselect
              v-if="!isLivechat || $route.name === 'allinonechat'"
              class="ma-0 mb-1 mr-1 ml-1"
              style="max-width: 100px"
              v-model="statusStatus"
              :close-on-select="true"
              :show-labels="false"
              :options="statusOptions"
              label="label"
              selectLabel
              selectedLabel
              :allow-empty="false"
              :searchable="false"
              deselect-label
              track-by="label"
              @select="onSelectStatus"
            >
            </multiselect>
            <v-btn
              @click="
                pageNumber = 1
                getIntent()
              "
              color="primary"
            >
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            :class="`form-control text-xs-right ${$route.name != 'allinonechat' ? 'sm6' : 'sm12'}`"
          >
            <v-btn class="ma-0 mb-1 mr-1" @click="expandAll" color="primary" outline>
              <i class="fas fa-expand-arrows-alt mr-1"></i>
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn class="ma-0 mb-1 mr-1" @click="collapseAll" color="primary" outline>
              <i class="fas fa-compress mr-1"></i>
              {{ $t('Collapse All') }}
            </v-btn>
          </v-flex>
        </v-layout>
        <template v-if="$route.name != 'allinonechat'">
          <div v-if="!isShow" :style="`margin-bottom: 10px; position: relative;`">
            <a href="javascript:void(0);" @click="addConversation" style="text-decoration: none">
              <div class="add-conversation text-xs-center">
                <i class="fa fa-plus middle"></i>
                {{ $t('Add conversation') }}
              </div>
            </a>
          </div>

          <div
            class="intent-item"
            v-else
            :style="`padding: 10px 15px 0px;border: 1px solid ${$vuetify.theme.primary};`"
          >
            <manage-intent
              :type="'add'"
              :isIntent="true"
              v-model="intent"
              @close="onClose"
              @saveIntent="onSaveIntent"
              :excludedIntentName="excludedIntentName"
              :hasTypeDateAndTime="isConversation"
            ></manage-intent>
          </div>
        </template>

        <v-layout
          v-if="
            $route.name != 'allinonechat' && !$store.state.centralPage.includes(selectedBot.pageid)
          "
          wrap
        >
          <v-flex xs12 sm3 style="align-self: center; margin-top: 15px;">
            <v-checkbox
              v-if="!loadingIntent"
              id="cbAll"
              :label="$t('Check all')"
              style="display: inline-block; margin: 0"
              v-model="checkboxAll"
              @change="clickCbAll"
              color="primary"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 sm9>
            <div class="text-xs-right mt-3">
              <v-btn class="ma-0 mb-1 mr-1" @click="deleteSelected" color="primary" outline>
                <i class="fas fa-trash mr-1"></i>
                {{ $t('delete_intent_selected') }}
              </v-btn>
              <v-btn class="ma-0 mb-1 mr-1" @click="showDialog = true" color="primary" outline>
                <i class="fas fa-trash mr-1"></i>
                {{ $t('delete_all') }}
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
          <!-- :total-visible="showsize" -->
          <v-pagination
            v-model="pageNumber"
            @input="
              getIntent()
              checkboxAll = false
            "
            :length="pageCount"
          ></v-pagination>
        </div>
        <!-- <transition-group
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:leave="leave"
        > -->
        <v-layout
          v-if="loadingIntent"
          justify-center
          column
          fill-height
          style="min-height: 500px"
          class="text-xs-center"
        >
          <div class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </v-layout>
        <intent-item
          v-else
          @sendToLivechat="sendToLivechat"
          v-for="(item, index) in paginateIntent"
          :key="'intent_' + item.id + '_' + index"
          @assignCb="assignCb"
          :cbAll.sync="cbAll"
          v-model="paginateIntent[index]"
          :filterIntents="paginateIntent"
          @onDelete="deleteIntent(index)"
          @onCopyIntent="copyIntent"
          :excludedIntentName="excludedIntentName"
          @onUpdate="onUpdateIntent"
          :livechatapp="livechatapp"
          :isLivechat="isLivechat"
          :group_id="group_id"
          :isIntent="true"
          :indexIntent="index"
          :pageNumber="pageNumber"
          :isConversation="isConversation"
        ></intent-item>
        <!-- </transition-group> -->

        <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
          <v-pagination
            v-model="pageNumber"
            :length="pageCount"
            @input="
              getIntent()
              checkboxAll = false
            "
          ></v-pagination>
        </div>
      </v-container>

      <v-divider></v-divider>

      <v-container>
        <h2>ChatGPT Plus (Beta)</h2>
        <intent-item
          v-if="selectedBot.businessExpriedDate && selectedBot.businessExpriedDate > 0"
          :group_id="group_id"
          :filterIntents="paginateIntent"
          :excludedIntentName="excludedIntentName"
          v-model="chatGPTIntent"
          :key="'intent_chat_gpt_' + chatGPTIntent.id"
          :welcomemessage="welcome_message"
          :livechatapp="livechatapp"
          :isLivechat="isLivechat"
          :isIntent="true"
        ></intent-item>
        <intent-item-lock type="business" text="upgrade_to_business_to_use_this_function" v-else />
      </v-container>

      <template v-if="showDefault">
        <v-container>
          <h2>{{ $t('Default Conversation') }}</h2>
          <intent-item
            :group_id="group_id"
            :filterIntents="paginateIntent"
            :excludedIntentName="excludedIntentName"
            v-model="default_intent"
            :key="'intent_default_' + default_intent.id"
            :welcomemessage="welcome_message"
            :livechatapp="livechatapp"
            :isLivechat="isLivechat"
            :isIntent="true"
          ></intent-item>
        </v-container>
      </template>
      <div class="mt-5 mb-5"></div>
    </template>

    <v-layout
      v-else
      justify-center
      column
      fill-height
      style="min-height: 300px"
      class="text-xs-center"
    >
      <div class="spinner text-xs-center" style="top: 100px;">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </v-layout>
    <v-dialog v-model="showDialog" max-width="500px">
      <v-card v-if="showDialog">
        <div style="position: absolute; right: 0px;">
          <v-btn fab small flat @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="text-xs-center">
            <i class="fas fa-info-circle mb-3" style="font-size: 50px; color:#ed1e78"></i>
          </div>
          <div class="text-xs-center" style="background: #ffe1ee; padding: 35px;">
            <div class="mb-1">{{ $t('confirm_delete') }}</div>
            <div class="form-control left-align" :class="{ 'has-error': errors.has('username') }">
              <input
                type="text"
                class="input form-control"
                aria-describedby="userid"
                :placeholder="$t('type_to_confirm_delete')"
                v-model="confirmDelete"
                v-validate="'required'"
                data-vv-as="Username"
                data-vv-name="username"
              />
            </div>
          </div>
          <div class="text-xs-center mt-2">
            <v-btn outline color="primary" class="" @click="showDialog = false">
              {{ $t('cancel') }}
            </v-btn>

            <v-btn depressed color="primary" @click="saveDeleteAll">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage'
import intentItem from './intent-item'
import intentItemLock from './intent-item-lock'
import Multiselect from 'vue-multiselect'
import api from '@/api'

import { cloneDeep } from 'lodash'
export default {
  props: {
    showDefault: {
      default: true,
      type: Boolean
    },
    isGetstarted: {
      default: false,
      type: Boolean
    },
    filterContext: {
      default: null
    },
    group_id: {
      default: null
    },
    pageid: {
      default: null
    },
    isLivechat: {
      default: false,
      type: Boolean
    },
    isConversation: {
      type: Boolean,
      default: false
    },
    livechatapp: {
      default: 'all'
    },
    total_count: {
      default: 0
    }
  },
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    'intent-item-lock': intentItemLock,
    Multiselect
  },
  data() {
    return {
      cbAll: [],
      checkboxAll: false,
      confirmDelete: '',
      showDialog: false,
      statusOptions: [
        {
          label: this.$t('All'),
          value: ''
        },
        {
          label: this.$t('Active'),
          value: 'true'
        },
        {
          label: this.$t('Inactive'),
          value: 'false'
        }
      ],
      statusStatus: {
        label: this.$t('All'),
        value: ''
      },
      showPagination: false,
      pageNumber: 1,
      pageCount: 0,
      isShow: false,
      showsize: 15,
      showModal: false,
      loading: true,
      loadingIntent: false,
      intent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_spec_ids: null,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        event_setting: {
          event_name: '',
          value: '',
          currency: 'THB'
        },
        time_setting: {
          Monday: { status: true, openat: null, closeat: null },
          Tuesday: { status: true, openat: null, closeat: null },
          Wednesday: { status: true, openat: null, closeat: null },
          Thursday: { status: true, openat: null, closeat: null },
          Friday: { status: true, openat: null, closeat: null },
          Saturday: { status: true, openat: null, closeat: null },
          Sunday: { status: true, openat: null, closeat: null }
        }
      },
      allIntents: [],
      intents: [],
      search: '',
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_intent: undefined,
      chatGPTIntent: undefined,
      currentpageid: null,
      max_intent: 300,
      all_count: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    filterIntents: function() {
      var vm = this
      if (!vm.intents) return []
      var intents = vm.intents
      if (this.filterContext) {
        intents = intents.filter(el => {
          return el.context_in == this.filterContext
        })
      }

      intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      return intents
    },
    paginateIntent() {
      if (this.filterIntents.length >= 100) {
        this.showPagination = true
        var start = (this.pageNumber - 1) * this.showsize
        var end = this.pageNumber * this.showsize
        var result = this.filterIntents.slice(start, end)
        return result
      } else {
        this.showPagination = true
        return this.filterIntents
      }
    },

    excludedIntentName: function() {
      var result = []
      var vm = this
      $.each(vm.allIntents, function(index, intent) {
        result.push(intent.intentname)
      })
      return result.join(',')
    },
    totalIntentWithoutDefault() {
      // var intentwithoutwelcome = this.intents.filter(el => {
      //   return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
      //     el.intentname
      //   )
      // })
      return this.intents.length
    }
  },
  async mounted() {
    var vm = this
    if (vm.pageid) {
      vm.currentpageid = vm.pageid
    } else {
      vm.currentpageid = vm.selectedBot.pageid
    }

    let package_config = vm.getPackageConfig()
    vm.max_intent = package_config.inbox
    if (vm.selectedBot.pageid == '1667559336833768') {
      vm.max_intent = 500
    }

    vm.loading = true
    vm.getLineNotify()
    try {
      await vm.getWelcomeMessage()
      await vm.getDefaultIntent()
      await vm.getChatGPTIntent()
    } catch (error) {}
    await vm.getIntent()
    vm.$emit('getIntent', vm.intents)
    if (
      vm.$store.getters.getPackage !== 'premium' &&
      vm.$store.state.selectedBot.facebook_page_id
    ) {
      await vm.$store.dispatch('getVerifyMeta', vm)
    }
    vm.loading = false

    if (vm.selectedBot.theme == 'ecommercebasic' && !['allinonechat'].includes(vm.$route.name)) {
      await vm.$store.dispatch('loadCategory')
      vm.$store.dispatch('loadProducts')
      vm.$store.dispatch('loadCharges')
      vm.$store.dispatch('loadSetting')
    }
  },
  methods: {
    async deleteSelected() {
      const vm = this

      if (vm.cbAll.length > 0) {
        const result = await vm.$swal.fire({
          title: vm.$t('confirm_delete_intent'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          let res = await vm.delete(
            `intents?ids=${vm.cbAll.toString()}&pageid=${vm.selectedBot.pageid}`
          )
          if (res.responsecode === 200) {
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: ``,
              type: 'success'
            })
            vm.cbAll = []
            vm.getIntent()
          }
          vm.$store.dispatch('loading')
        }
      } else {
        await vm.$swal.fire({
          title: vm.$t('select_conversation_before_delete'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
      }
    },
    assignCb(id) {
      if (this.cbAll.includes(id)) this.cbAll = this.cbAll.filter(v => id != v)
      else {
        this.cbAll.push(id)
      }
    },
    clickCbAll() {
      if (this.checkboxAll) {
        this.paginateIntent.map(v => {
          this.cbAll.push(v.id)
        })
        this.checkboxAll = true
      } else {
        this.cbAll = this.cbAll.filter(elem => {
          return !this.paginateIntent.some(ele => {
            return ele.id === elem
          })
        })

        this.checkboxAll = false
      }
    },
    async saveDeleteAll() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (result) {
        if (vm.confirmDelete === 'confirm') {
          vm.$store.dispatch('loading')
          let res = await vm.delete(`page/${vm.selectedBot.pageid}/delete-all-conversation-intent`)
          if (res.success) {
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: ``,
              type: 'success'
            })
            vm.confirmDelete = ''
            vm.showDialog = false
            vm.getIntent()
          }
          vm.$store.dispatch('loading')
        }
      }
    },
    sendToLivechat(intent, userid) {
      this.$emit('sendToLivechat', { ...intent, type: 'json' }, { userid })
    },
    getLineNotify: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.currentpageid }, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            let linenotifylist = []
            response.linenotifylist.map(async item => {
              if (item.adminid.charAt(0) === 'U') {
                var data = {
                  pageId: vm.selectedBot.pageid,
                  adminId: item.adminid
                }
                var response = await api.getAdminInfo(data)
                if (response.success && response.result) {
                  item.name = response.result.line_display_name
                  item.line_picture_url = response.result.line_picture_url
                }
              } else if (!item.name) {
                item.name = item.adminid
              }
              linenotifylist.push(item)
            })
            vm.$store.commit('SET_LINENOTIFY_LIST', linenotifylist)
          }
          resolve()
        })
      })
    },
    beforeEnter: function(el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    onSaveIntent: async function(payload) {
      var vm = this
      if (payload.a_val) {
        let hasMatch = JSON.parse(payload.a_val)[0].some(function(value) {
          return value.type == 'ntn_template'
        })
        if (hasMatch) {
          await vm.getIntent()
        } else {
          vm.$store.commit('REMOVE_EDITTING_INTENT', vm.intent.id)
          vm.isShow = false
          payload.isShow = true
          vm.intents.push(payload)
          vm.allIntents.push(payload)
          vm.$store.commit('SET_INTENT', payload)
          vm.lastedIntentName = payload.intentname
        }
      }
      vm.intent = cloneDeep(vm.intentTemplate())
      vm.isSave = true
      vm.onClose()
      vm.isSave = false
      vm.$swal.fire({
        title:
          vm.$t('conversation') +
          ' "' +
          payload.intentname.replace(/\<|\>/g, '') +
          '" ' +
          vm.$t('added'),
        type: 'success',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      vm.getIntent()
    },
    copyIntent: function(payload) {
      if (this.$store.getters.getPackage != 'premium' && this.all_count >= 10) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'conversations_you_have_reached_the_limit_for_the_package'
            )}${this.$t('upgrade_to_advanced_now')}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              this.$router.push('Upgrade').catch(() => {})
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.all_count >= this.max_intent &&
        !this.$store.state.UnlimitedConversation.includes(this.currentpageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'conversations_you_have_reached_the_limit_for_the_package'
            )}${this.$t('please_contact_us')}</b>`,
            confirmButtonText: this.$t('contact_us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        payload.onCopy().then(result => {
          result.isShow = true
          this.intents.push(result)
          this.allIntents.push(result)
          var vm = this
          vm.$swal.fire({
            title:
              vm.$t('conversation') +
              ' "' +
              // result.intentname.replace(/\<|\>/g, '') +
              result.intentname.replace(/\<|\>/g, '').replaceAll('&not', '&amp;not') +
              '" ' +
              vm.$t('added'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        })
      }
    },
    onClose: function(payload) {
      this.isShow = false
      this.$store.commit('REMOVE_EDITTING_INTENT', this.intent.id)
      // this.intents.push(payload)
      // this.getIntent()
    },
    onSelectStatus(param) {
      const vm = this
      vm.statusStatus = param
      // vm.getIntent()
    },
    getIntent: function() {
      let vm = this
      vm.loadingIntent = true
      let data = {
        pageid: vm.currentpageid,
        limit: vm.showsize,
        offset: (vm.pageNumber - 1) * vm.showsize,
        page_intent: 'conversation',
        search_intent: vm.search || '',
        sort_by: 'intentname',
        sort_type: 'asc',
        intent_status: vm.statusStatus && vm.statusStatus.value ? vm.statusStatus.value : ''
      }
      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.pageCount = Math.ceil(response.total_count / vm.showsize)
            var intents = response.data.map(function(val) {
              var intent = { ...val }
              intent.isShow = false
              intent.ableToDelete = true
              return intent
            })
            vm.$emit('update:total_count', response.total_count)
            vm.$emit('update:all_count', response.all_count)
            vm.all_count = response.all_count
            vm.allIntents = intents
            vm.intents = intents.filter(el => {
              return (
                el.context_in != 'comment' &&
                el.intentname != '{default}' &&
                el.intentname != '{welcome}'
              )
            })
            vm.checkboxAll = vm.intents.every(o => vm.cbAll.some(v => v === o.id))
          }
          vm.loadingIntent = false
          resolve()
        })
      })
    },

    getDefaultIntent() {
      let vm = this
      vm.loadingIntent = true
      let data = {
        pageid: vm.currentpageid,
        page_intent: 'conversation',
        intent_name: '{default}'
      }
      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.pageCount = Math.ceil(response.total_count / vm.showsize)
            const intents = response.data.map(function(val) {
              let intent = { ...val }
              intent.isShow = false
              intent.ableToDelete = true
              return intent
            })
            var default_intent = intents.find(el => {
              return el.intentname == '{default}'
            })

            if (default_intent) {
              default_intent.ableToDelete = false
              vm.default_intent = default_intent
            } else {
              vm.default_intent = cloneDeep(vm.intentTemplate())
              vm.$set(vm.default_intent, 'intentname', '{default}')
              vm.$set(vm.default_intent, 'a_val', '[[]]')
              vm.$set(vm.default_intent, 'ableToDelete', false)
              vm.$set(vm.default_intent, 'isShow', false)
            }
          }

          vm.loadingIntent = false
          resolve()
        })
      })
    },

    getChatGPTIntent() {
      let vm = this
      vm.loadingIntent = true

      let data = {
        pageid: vm.currentpageid,
        page_intent: 'conversation',
        intent_name: '{default_gpt}'
      }

      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.pageCount = Math.ceil(response.total_count / vm.showsize)

            const intents = response.data.map(function(val) {
              let intent = { ...val }
              intent.isShow = false
              intent.ableToDelete = true
              return intent
            })
            const chatGPTIntent = intents.find(el => {
              return el.intentname == '{default_gpt}'
            })

            if (chatGPTIntent) {
              chatGPTIntent.ableToDelete = false
              vm.chatGPTIntent = chatGPTIntent
            } else {
              vm.chatGPTIntent = cloneDeep(vm.intentTemplate())
              vm.$set(vm.chatGPTIntent, 'intentname', '{default_gpt}')
              vm.$set(vm.chatGPTIntent, 'a_val', '[[]]')
              vm.$set(vm.chatGPTIntent, 'ableToDelete', false)
              vm.$set(vm.chatGPTIntent, 'isShow', false)
            }
          }

          vm.loadingIntent = false
          resolve()
        })
      })
    },

    deleteIntent: function(index) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.paginateIntent[index].intentname.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let data = {
              id: vm.paginateIntent[index].id,
              pageid: vm.currentpageid
            }
            vm.$store.dispatch('loading')
            api.deleteIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              vm.$swal.fire({
                title: vm.$t('Successfully'),
                text: vm.$t('conversation_has_been_deleted'),
                type: 'success'
              })
              // vm.$store.commit('DELETE_INTENT', data.id)
              vm.getIntent()
              $.each(vm.intents, function(intent_index, intent) {
                if (intent.id == data.id) {
                  vm.intents.splice(intent_index, 1)
                  return false
                }
              })
              // if (vm.allIntents) {
              //   var findIndex = vm.allIntents.find(function(el) {
              //     return el.id == data.id
              //   })

              //   if (findIndex > -1) {
              //     vm.allIntents.splice(findIndex, 1)
              //   }
              // }
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    getWelcomeMessage: function() {
      let vm = this
      let data = {
        pageid: vm.currentpageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      return new Promise((resolve, reject) => {
        api.getWelcomeMessage(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.welcome_message.type = response.data.type
            vm.welcome_message.message = response.data.message_text
              ? response.data.message_text
              : ''

            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              $.each(response.data.message, function(index, val) {
                vm.welcome_message.generics[index] = val
              })
            }

            if (
              response.data.message_quickreplies &&
              response.data.message_quickreplies != '' &&
              response.data.message_quickreplies != null
            ) {
              vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
            } else {
              vm.welcome_message.quick_reply = []
            }
          }
          resolve()
        })
      })
    },
    addConversation() {
      let account_packages = this.getPackageType()
      if (
        account_packages.includes('enterprise') ||
        this.$store.state.UnlimitedConversation.includes(this.currentpageid)
      ) {
        // unlimited
      } else if (account_packages.includes('business') || account_packages.includes('advanced')) {
        if (this.all_count >= this.max_intent) {
          this.$swal
            .fire({
              html: `<b class="intentmax"> ${this.$t(
                'conversations_you_have_reached_the_limit_for_the_package'
              )}${this.$t('please_contact_us')}</b>`,
              confirmButtonText: this.$t('contact_us'),
              confirmButtonColor: this.$vuetify.theme.primary
            })
            .then(result => {
              if (result.value) {
                window.location.assign('https://www.facebook.com/messages/t/zwizai')
              }
            })
          return false
        }
      } else {
        if (this.all_count >= this.max_intent) {
          this.$swal
            .fire({
              html: `<b class="intentmax"> ${this.$t(
                'conversations_you_have_reached_the_limit_for_the_package'
              )}${this.$t('upgrade_to_advanced_now')}</b>`,
              confirmButtonText: this.$t('Upgrade now'),
              confirmButtonColor: this.$vuetify.theme.primary
            })
            .then(result => {
              if (result.value) {
                this.$router.push('Upgrade').catch(() => {})
              }
            })
          return false
        }
      }
      this.isShow = true
      this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
    },
    expandAll: function() {
      var vm = this
      $.each(vm.intents, function(index, intent) {
        vm.intents[index].isShow = true
      })
      vm.default_intent.isShow = true
    },
    collapseAll: function() {
      var vm = this
      $.each(vm.intents, function(index, intent) {
        vm.intents[index].isShow = false
      })
      vm.default_intent.isShow = false
    },
    onUpdateIntent: function(payload) {
      var vm = this
      var index = vm.intents.findIndex(el => {
        return el.id == payload.id
      })
      if (index > -1) {
        vm.$set(vm.intents, index, payload)
      }
    },
    clearSearch() {
      const vm = this
      vm.search = ''
      vm.getIntent()
    }
  },
  watch: {
    selectedBot: function(newVal, oldVal) {
      // if (newVal != oldVal) this.getIntent(function() {})
    }
  }
}
</script>

<style lang="scss" scoped>
.intentmax {
  font-size: 22px;
}
.input-icons {
  display: contents;
  i {
    position: absolute;
  }
  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }
  .icon {
    padding: 16px;
    min-width: 50px;
  }
  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Intent.vue